// v17.10.avatar-fallback (Feb 2026, pass 2) — Global handler <img> avatar lỗi.
//
// Bối cảnh: nhiều users có `avatar_url` trỏ tới ORIGINAL Spaces file đã bị
// xoá (403 AccessDenied) sau khi `compress_and_swap_avatar` upload thất bại
// giữa chừng. Nhưng `avatar_thumb_url` VẪN CÒN (upload trước khi crash).
// Fallback ĐÚNG là hiển thị THUMB, KHÔNG PHẢI DiceBear.
//
// Chain listener (chỉ áp dụng cho img có dấu hiệu avatar):
//   1. data-avatar-fallback-src (thumb URL FE truyền vào)  ← ưu tiên
//   2. src replace `.jpg`/`.png` → `-thumb.$ext` (guess thumb cùng ts)
//   3. DiceBear seed từ alt/data-avatar-seed              ← cuối cùng
//
// Guard: data-avatar-fallback-step counter chống loop; skip khi src đã là
// URL đích của fallback rồi.

const _AVATAR_URL_RE = /\/avatars?\/[^/]+\.(?:jpe?g|png|webp|gif)/i;

// v17.perf.track1 (02-2026) — Loại DiceBear (13 external requests trên HAR
// livestream). Fallback cuối cùng nay là 1 SVG local static tại
// /avatar-fallback.svg (đã có sẵn trong public/). Không còn network call.
const _FALLBACK_SVG = "/avatar-fallback.svg";

function _dicebear(_seed) {
  return _FALLBACK_SVG;
}

function _seedFromEl(el) {
  return (
    el.dataset.avatarSeed ||
    (el.alt || "").trim() ||
    "guest"
  );
}

function _guessThumbFromSrc(src) {
  // `.../avatars/{uid}-{ts}.jpg` → `.../avatars/{uid}-{ts}-thumb.jpg`
  // KHÔNG áp dụng nếu URL đã có `-thumb` hoặc `-c` (đã là variant).
  if (!src) return null;
  if (/-thumb\.(jpe?g|png|webp)$/i.test(src)) return null;
  if (/-c\.(jpe?g|png|webp)$/i.test(src)) return null;
  return src.replace(/(\.(jpe?g|png|webp|gif))(\?.*)?$/i, "-thumb$1$3");
}

function _isAvatarImage(el) {
  if (!el || el.tagName !== "IMG") return false;
  const src = el.currentSrc || el.src || "";
  if (!src) return false;
  if (_AVATAR_URL_RE.test(src)) return true;
  if (el.dataset.avatarFallback === "1") return true;
  return false;
}

function _handleErrorCapture(event) {
  const el = event.target;
  if (!_isAvatarImage(el)) return;
  const step = Number(el.dataset.avatarFallbackStep || 0);
  if (step >= 3) return;  // hết chain, bỏ

  let next = null;

  if (step === 0) {
    // Step 1: dùng fallbackSrc FE truyền vào (đáng tin nhất).
    const explicit = el.dataset.avatarFallbackSrc;
    if (explicit && explicit !== el.src) {
      next = explicit;
    }
  }
  if (!next && step <= 1) {
    // Step 2: đoán thumb variant từ URL hiện tại (thumbs cùng bucket).
    const guessed = _guessThumbFromSrc(el.currentSrc || el.src);
    if (guessed && guessed !== el.src) {
      next = guessed;
    }
  }
  if (!next) {
    // Step 3: DiceBear cuối cùng (last resort).
    next = _dicebear(_seedFromEl(el));
  }

  if (next && next !== el.src) {
    el.dataset.avatarFallbackStep = String(step + 1);
    el.src = next;
  }
}

let _wired = false;
export function installAvatarFallback() {
  if (_wired || typeof window === "undefined") return;
  _wired = true;
  // capture=true → chạy trước listener bubble (kể cả React synthetic onError).
  // Nếu component đã có onError riêng và ĐÃ swap src → listener global thấy
  // src mới, xem xét lại; nếu chưa → global tự chain.
  window.addEventListener("error", _handleErrorCapture, true);
}

installAvatarFallback();
